<template>
  <div id="wrapper">
    <Spinner :isLoading="isLoading" />
    <div class="login-logo">
      <h1>
        <img src="/common/img/logo.png" alt="nanacara for Doctor" height="40" />
      </h1>
      <div style="margin-top: 35px">
        <p class="mb30" style="font-size: 20px">電話番号登録</p>
        <p class="mb10">
          2段階認証をONにするためには電話番号の登録が必要です。<br />
          電話番号登録ではご本人様確認のため、携帯番号のSMS (ショートメッセージサービス) を利用して認証を行います。 <br />
        </p>
      </div>
    </div>
    <div id="login-wrap">
      <div>
        <form @submit.prevent="registerPhoneNumber()" method="post">
          <p class="mb20">電話番号</p>
          <input
            type="text"
            name="tel"
            inputmode="numeric"
            oninput="this.value = this.value.replace(/[^0-9]/g, '');"
            id=""
            autocomplete="off"
            class="mb50"
            v-model="phoneNumber"
          />
          <div v-if="submitted">
            <p class="error-txt mb20" v-if="$v.phoneNumber.$error && !$v.phoneNumber.required.$response">
              電話番号が未入力です。
            </p>
            <p v-else-if="errRegexTel" class="error-txt mb20">
              電話番号の形式が違います。
            </p>
            <p v-else-if="errAddPhoneNumber" class="error-txt mb20">
              {{ errAddPhoneNumber }}
            </p>
          </div>
        </form>

        <div class="btn-base mb30" v-on:click="addPhoneNumber()">
          <a href="javascript:;"><p>次へ</p></a>
        </div>
        <div class="btn-cancel"
          style="background: #fff; border: 1px solid #ffa300"
          v-on:click="cancelAddPhoneNumber()">
          <a href="javascript:;"><p>キャンセル</p></a>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import Spinner from "@/js/components/Spinner";
export default {
  data() {
    return {
      phoneNumber: "",
      submitted: false,
      isLoading: false,
      errRegexTel: false,
      regexTel: /^0[0-9]{9,10}$/
    };
  },
  validations: {
    phoneNumber: { required },
  },
  components: {
    Spinner,
  },
  computed: {
    ...mapState({
      access_token: (state) => state.auth.access_token,
      errAddPhoneNumber: (state) => state.auth.errAddPhoneNumber,
    }),
  },
  async mounted() {
    this.screenTracking(this.$t("those_who_have_forgotten_PW"));
  },
  methods: {
    async addPhoneNumber() {
      this.submitted = true;
      this.$v.$touch();
      let params = {
        phone_number: this.phoneNumber,
        access_token: this.access_token,
      };
      if (!this.$v.phoneNumber.$error && !this.errRegexTel) {
        this.isLoading = true;
        await this.$store.dispatch("auth/addPhoneNumber", params);
        this.isLoading = false;
        if (this.errAddPhoneNumber == "") {
          this.$router.push("/confirm-phone-number");
        }
      } else {
        return;
      }
    },
    cancelAddPhoneNumber() {
        this.$router.push("/settings")
    }
  },
  watch: {
    'phoneNumber': function () {
      if (this.phoneNumber) {
        this.$store.dispatch("auth/clearErrMessage");
        if (!this.phoneNumber.match(this.regexTel)) {
          this.errRegexTel = true;
        } else {
          this.errRegexTel = false;
        }
      } else {
        this.errRegexTel = false;
      }
    },
  },
};
</script>
  <style scoped>
.error-txt {
  color: #ff0000;
  font-size: 0.8rem;
}
</style>
